import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useTrackingContext } from './context';
import type { TrackingFn } from './types';

export function useTracking(): TrackingFn {
	const utilityContext = useUtilityContext();
	const context = useTrackingContext();

	// TODO remove tracker from utility context?
	return context || utilityContext.tracker.__internal__track__;
}
